export default {
  primary: '#2E038C',
  primaryDark: '#1B0B37',
  primaryLight: '#A7A3F9',
  secondary: '#F92AC2', //EA3CF7
  secondaryLight: '#FFD2F5',
  accent: '#8c9eff',
  error: '#b71c1c',
  turquoise: '#00F4D9',
  yellowLight: '#FFFF00',
  whitePure: '#FFFFFF',
  greyDarker: '#626262',
  greyDark: '#848484',
  greyLight: '#DBDBDB',
  greyLighter: '#ECECEC',
  backgroundList: '#FAFAFA',
  backgroundGrey: '#F5F5F5',
}



// WEBPACK FOOTER //
// ./src/themes/color.ts